/** Produtos com qtd por palete - VOL. 1, VOL. 2, VOL. 3 */

export function ordenarProdutosPalete<T extends { produto: string }>(lista: T[]): T[] {
  return [...lista].sort((a, b) => {
    const na = (a.produto || '').trim();
    const nb = (b.produto || '').trim();
    if (!na && nb) return 1;
    if (na && !nb) return -1;
    return na.localeCompare(nb, 'pt-BR', { sensitivity: 'base', numeric: true });
  });
}

export const PRODUTOS_PALETE_INICIAL: Array<{ produto: string; vol1: number; vol2?: number; vol3?: number }> = ordenarProdutosPalete([
  { produto: 'APARADOR BARI 1.0', vol1: 28 },
  { produto: 'APARADOR LUIS XV', vol1: 23 },
  { produto: 'APARADOR MADERATTO', vol1: 36 },
  { produto: 'APARADOR MEMPHIS', vol1: 20 },
  { produto: 'BAR ADEGA BALI', vol1: 40 },
  { produto: 'BALCAO OSLO', vol1: 28 },
  { produto: 'BOMBE LUIS XV', vol1: 16 },
  { produto: 'BUFFET AÇORES 1.4', vol1: 31, vol2: 36 },
  { produto: 'BUFFET AÇORES 1.9', vol1: 32, vol2: 24 },
  { produto: 'BUFFET ANDORRA 1.3', vol1: 20 },
  { produto: 'BUFFET ANDORRA 1.72', vol1: 22 },
  { produto: 'BUFFET SIERRA 1.3', vol1: 20 },
  { produto: 'BUFFET SIERRA 1.72', vol1: 22 },
  { produto: 'BUFFET ARGO 0.9', vol1: 16 },
  { produto: 'BUFFET ARGO 1.4', vol1: 24, vol2: 35 },
  { produto: 'BUFFET MADERATTO 3 PORTAS', vol1: 12 },
  { produto: 'BUFFET MADERATTO 4 PORTAS', vol1: 34, vol2: 24 },
  { produto: 'BUFFET MAGNUM 0.9', vol1: 17 },
  { produto: 'BUFFET MAGNUM 1.4', vol1: 19, vol2: 49 },
  { produto: 'BUFFET MAGNUM 1.9', vol1: 25, vol2: 42 },
  { produto: 'BUFFET PASSION', vol1: 24, vol2: 42 },
  { produto: 'BUFFET UNION', vol1: 28, vol2: 49 },
  { produto: 'EXPOSITOR 2.1', vol1: 27 },
  { produto: 'HOME LENI', vol1: 25, vol2: 22, vol3: 35 },
  { produto: 'HOME RENO', vol1: 32, vol2: 20, vol3: 38 },
  { produto: 'HOME ROYAL', vol1: 32, vol2: 22 },
  { produto: 'MESA APOIO DUQUESA', vol1: 56 },
  { produto: 'MESA APOIO WOOD', vol1: 42 },
  { produto: 'MESA CAB. LUCCA', vol1: 35 },
  { produto: 'MESA CAB. LUIS XV', vol1: 35 },
  { produto: 'MESA CENTRO DUQUESA', vol1: 28 },
  { produto: 'MESA CENTRO HOLAMBRA', vol1: 30 },
  { produto: 'MESA CENTRO PRATIKA', vol1: 27 },
  { produto: 'MESA LATERAL DUQUESA', vol1: 54 },
  { produto: 'MESA MADERATTO', vol1: 30 },
  { produto: 'MESA URBAN', vol1: 49 },
  { produto: 'MESA CITY', vol1: 49 },
  { produto: 'MODULO EXPANSIVO', vol1: 31 },
  { produto: 'NICHO ASPEN 1.35', vol1: 36 },
  { produto: 'NICHO ASPEN 1.8', vol1: 46 },
  { produto: 'NICHO ASPEN 2.17', vol1: 50 },
  { produto: 'NICHO DIOR 1.1', vol1: 61 },
  { produto: 'NICHO DIOR 1.6', vol1: 55 },
  { produto: 'NICHO DIOR 2.0', vol1: 66 },
  { produto: 'NICHO UNIVERSAL 1.35', vol1: 44 },
  { produto: 'NICHO UNIVERSAL 1.8', vol1: 44 },
  { produto: 'NICHO UNIVERSAL 2.2', vol1: 44 },
  { produto: 'NICHO VERSTTI 1.35', vol1: 54 },
  { produto: 'NICHO VERSTTI 1.8', vol1: 66 },
  { produto: 'NICHO VERSTTI 2.2', vol1: 55 },
  { produto: 'PAINEL ARBO 0.9', vol1: 31 },
  { produto: 'PAINEL ARBO 1.4', vol1: 46, vol2: 41 },
  { produto: 'PAINEL ARBO 1.9', vol1: 27, vol2: 41 },
  { produto: 'PAINEL ARBO 2.3', vol1: 40, vol2: 31, vol3: 41 },
  { produto: 'PAINEL AREZZO', vol1: 24 },
  { produto: 'PAINEL ASTON', vol1: 35, vol2: 54 },
  { produto: 'PAINEL AVANT 1.4 e 1.8', vol1: 32 },
  { produto: 'PAINEL BLISS 1.8', vol1: 23 },
  { produto: 'PAINEL BLISS 2.2', vol1: 36, vol2: 70 },
  { produto: 'PAINEL CONDOR', vol1: 25 },
  { produto: 'PAINEL DAVOS', vol1: 26 },
  { produto: 'PAINEL DIJON', vol1: 24 },
  { produto: 'PAINEL EGEO 1.4', vol1: 35 },
  { produto: 'PAINEL EGEO 1.8', vol1: 42, vol2: 51 },
  { produto: 'PAINEL EGEO 2.3', vol1: 32, vol2: 51 },
  { produto: 'PAINEL FOX', vol1: 44 },
  { produto: 'PAINEL GARDEN 1.8', vol1: 27 },
  { produto: 'PAINEL GARDEN 2.2', vol1: 27 },
  { produto: 'PAINEL LEGACY 1.6', vol1: 36 },
  { produto: 'PAINEL LEGACY 2.0', vol1: 36 },
  { produto: 'PAINEL MADERATTO 1.8', vol1: 36, vol2: 43 },
  { produto: 'PAINEL MADERATTO 2.0', vol1: 36, vol2: 43 },
  { produto: 'PAINEL MADERATTO 2.2', vol1: 36, vol2: 43 },
  { produto: 'PAINEL MASTER 1.4', vol1: 25 },
  { produto: 'PAINEL MASTER 1.8', vol1: 31, vol3: 31 },
  { produto: 'PAINEL MASTER 2.2', vol1: 25, vol3: 28 },
  { produto: 'PAINEL MAXI', vol1: 26 },
  { produto: 'PAINEL MERLOT 1.8', vol1: 40 },
  { produto: 'PAINEL MILOS', vol1: 33 },
  { produto: 'PAINEL MURANO', vol1: 20, vol2: 40 },
  { produto: 'PAINEL STUDIO 1.6', vol1: 30 },
  { produto: 'PAINEL STUDIO 2.18', vol1: 32 },
  { produto: 'PAINEL TORINO 2', vol1: 27 },
  { produto: 'PAINEL VEYRON 2.0', vol1: 40, vol2: 38 },
  { produto: 'PAINEL VEYRON 2.4', vol1: 29, vol2: 50 },
  { produto: 'RACK ARUBA', vol1: 28 },
  { produto: 'RACK CAYMAN', vol1: 28 },
  { produto: 'RACK AUSTIN', vol1: 23 },
  { produto: 'RACK BLISS 1.8', vol1: 42, vol2: 29 },
  { produto: 'RACK BLISS 2.2', vol1: 42, vol2: 29 },
  { produto: 'RACK C/ PAINEL AUDAX', vol1: 17 },
  { produto: 'RACK COMODORO 1.8', vol1: 21 },
  { produto: 'RACK COMODORO 2.2', vol1: 27, vol2: 40 },
  { produto: 'RACK DARIM', vol1: 20 },
  { produto: 'RACK FELIX', vol1: 20 },
  { produto: 'RACK HANOVER 1.8', vol1: 25, vol2: 41 },
  { produto: 'RACK HANOVER 2.2', vol1: 25, vol2: 41 },
  { produto: 'RACK KING', vol1: 23 },
  { produto: 'RACK ANDROS', vol1: 23 },
  { produto: 'RACK LEGACY 1.6', vol1: 23 },
  { produto: 'RACK LEGACY 1.8', vol1: 36, vol2: 42 },
  { produto: 'RACK LEGACY 2.0', vol1: 24 },
  { produto: 'RACK MADERATTO 1.8', vol1: 47, vol2: 24 },
  { produto: 'RACK MADERATTO 2.2', vol1: 46, vol2: 23 },
  { produto: 'RACK MASTER 1.8', vol1: 32, vol2: 24 },
  { produto: 'RACK MASTER 2.2', vol1: 24, vol2: 24 },
  { produto: 'RACK MERLOT 1.8', vol1: 36, vol2: 55 },
  { produto: 'RACK MORGAN 1.8', vol1: 29 },
  { produto: 'RACK MORGAN 2.2', vol1: 23, vol2: 63 },
  { produto: 'RACK STAR', vol1: 26 },
  { produto: 'RACK TITAN', vol1: 24 },
  { produto: 'RACK VIGO 1.8', vol1: 35, vol2: 28 },
  { produto: 'RACK VIGO 2.2', vol1: 35, vol2: 28 },
  { produto: 'RACK GLOSS 1.8', vol1: 35, vol2: 28 },
  { produto: 'RACK GLOSS 2.2', vol1: 35, vol2: 28 },
  { produto: 'RACK VINCI', vol1: 24 },
  { produto: 'RACK VITRAL', vol1: 28 },
]);
